import React from 'react';

interface StressTest {
  color: string;
  icon: React.ReactNode;
  label: string;
}


interface StressTestsAlertsProps {
  tests: StressTest[];
}

const StressTestsAlerts: React.FC<StressTestsAlertsProps> = ({ tests }) => {
  // Limite à 4 tests affichés
  const effectiveStressTests = tests || [];
  return (
    <section style={{
      background: '#fff',
      borderRadius: 24,
      padding: '32px 40px',
      boxShadow: '0 2px 16px #0001',
      minHeight: 80,
      marginTop: 0,
    }}>
      <div style={{ fontSize: 22, fontWeight: 700, color: '#e53935' }}>Stress Tests & Alertes</div>
      <ul style={{
        margin: 0,
        padding: 0,
        listStyle: 'none',
        marginTop: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}>
        {effectiveStressTests.slice(0, 4).map((test, idx) => (
          <li key={idx} style={{ color: test.color, fontWeight: 600 }}>{test.icon} {test.label}</li>
        ))}
      </ul>
    </section>
  );
};

export default StressTestsAlerts;
